import {
  fetchWrapper,
  handleResponse,
  formatBody,
  hcUrlV3,
  buildOpts,
} from 'services/RequestService/helpers';

const createEvents = async ({ params: { eventName } }) => {
  const location = window.location.href;
  const eventDeduplicationId = document
    .getElementById('hc-sign-up-funnel-react-app')
    ?.getAttribute('data-event-deduplication-id');

  const response = await fetchWrapper(
    hcUrlV3('/sign_up/events'),
    buildOpts({
      method: 'POST',
      body: formatBody({
        event: {
          eventName: eventName,
          originalUrl: location,
          eventDeduplicationId,
        },
      }),
    })
  );
  return handleResponse(response);
};

export { createEvents };
